import {DepartmentsClient} from '@client/departments-client'
import {Sync} from '@client/sync'
import {isAdmin} from '@components/dashboard/dashboard-utils'
import {createUseStore} from '@containers/hooks'
import {makeAutoObservable, observable} from 'mobx'
import {DataObjectId, Department} from 'yougile-model'
import {SearchUtil} from 'yougile-util'

interface State {
  departments: Department[]
  allUsers: DataObjectId[]
  filtered: Department[]
  filterQuery: string
  maxShow: number
  isAdmin: boolean
}

export class DepartmentsEditStore {
  state: State = {
    departments: [],
    allUsers: [],
    filtered: [],
    filterQuery: '',
    maxShow: 8,
    isAdmin: false
  }

  constructor() {
    makeAutoObservable(this, {
      state: observable.shallow
    })
  }

  calculateIsAdmin(): void {
    this.state.isAdmin = isAdmin()
  }

  calculateDepartments(): void {
    const box = Sync.getCurrentSandbox()
    this.state.departments = DepartmentsClient.listDepartments(box)
  }

  calculateAllUsers(): void {
    const box = Sync.getCurrentSandbox()
    this.state.allUsers = box.getAllUsers(false).map(u => u.id)
  }

  showMore(): void {
    this.state.maxShow += 50
  }

  changeFilterQuery(value: string): void {
    this.state.filterQuery = value
  }

  calculateFiltered(): void {
    const words = SearchUtil.prepareWords(
      SearchUtil.cleanStr(this.state.filterQuery)
    )
    const res: Department[] = []
    this.state.departments.forEach(project => {
      const name = SearchUtil.cleanStr(project.title)
      if (SearchUtil.hasAllWords(name, words)) {
        res.push(project)
        return
      }
    })
    this.state.filtered = res
  }

  calculate(): void {
    this.calculateDepartments()
    this.calculateIsAdmin()
    this.calculateAllUsers()
  }
}

const [DepartmentsEditContext, useDepartmentsEditStore] =
  createUseStore(DepartmentsEditStore)
export {DepartmentsEditContext, useDepartmentsEditStore}
